export default "__VITE_ASSET__G27b1YpQ__";